import * as v from 'valibot';
import { stringRequiredSchema } from '../../schemas/shared/string-required';

export const personalDataFormSchema = v.object({
  initials: stringRequiredSchema,
  firstname: stringRequiredSchema,
  lastname: stringRequiredSchema,
  statement: v.boolean(),
})
